import emailjs from '@emailjs/browser'

// EmailJS configuration
// You'll need to sign up at https://www.emailjs.com/ and get these values:
// 1. Create an account (free tier allows 200 emails/month)
// 2. Add an email service (Gmail, Outlook, etc.)
// 3. Create an email template
// 4. Get your Public Key, Service ID, and Template ID

const EMAILJS_PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY'
const EMAILJS_SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID'
const EMAILJS_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID || 'YOUR_TEMPLATE_ID'

// Initialize EmailJS
emailjs.init(EMAILJS_PUBLIC_KEY)

export interface ContactFormData {
  name: string
  organization?: string
  email: string
  message: string
}

export async function sendContactEmail(data: ContactFormData): Promise<{ success: boolean; error?: string }> {
  try {
    // Template parameters that will be sent to EmailJS
    const templateParams = {
      from_name: data.name,
      from_email: data.email,
      organization: data.organization || 'Not specified',
      message: data.message,
      to_email: 'vincentmasci@icloud.com', // Your email
      reply_to: data.email,
    }

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    )

    if (response.status === 200) {
      return { success: true }
    } else {
      return { success: false, error: 'Failed to send email. Please try again.' }
    }
  } catch (error) {
    console.error('Email service error:', error)
    return { 
      success: false, 
      error: 'Failed to send message. Please email us directly at vincentmasci@icloud.com' 
    }
  }
}

// Instructions for setting up EmailJS:
// 1. Go to https://www.emailjs.com/ and create a free account
// 2. In the Email Services section, add your email service (e.g., Gmail)
// 3. Create an email template with these variables:
//    - {{from_name}} - Sender's name
//    - {{from_email}} - Sender's email
//    - {{organization}} - Organization name
//    - {{message}} - Message content
//    - {{reply_to}} - Reply-to email
// 4. Get your Public Key from Account > General
// 5. Get your Service ID from Email Services
// 6. Get your Template ID from Email Templates
// 7. Add these to your .env.local file:
//    NEXT_PUBLIC_EMAILJS_PUBLIC_KEY=your_public_key
//    NEXT_PUBLIC_EMAILJS_SERVICE_ID=your_service_id
//    NEXT_PUBLIC_EMAILJS_TEMPLATE_ID=your_template_id